module.exports = __webpack_public_path__ + "static/img/ie.c68ff961.svg";